import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import "amfe-flexible";
import "./util/rem.js";
import request from "./util/request";

import ElementPlus from "element-plus";
// import "element-plus/lib/theme-chalk/index.css";
import "element-plus/dist/index.css";
createApp(App)
  .use(store)
  .use(router)
  .use(ElementPlus, { size: "large", zIndex: 3000 })
  .use(request)
  .mount("#app");
